import {Link} from "@/i18n/routing";
import {useTranslations} from 'next-intl';
import {useState} from 'react';

export default function ProductCategories({ categories, onCategorySelect, onSubcategorySelect, categoryInput, subcategoryInput }) {
  const t = useTranslations('catalog');
  const [openedIdx, setOpenedIdx] = useState();
  
  const onSubcategory = (e, alt1, title1, isActive, idx) => {
    if (subcategoryInput === alt1) {
      setOpenedIdx(idx);
    }
    onSubcategorySelect(e, alt1, title1, isActive);
  }
  
  return (
      <div className="widget">
        <h4 className="ltn__widget-title ltn__widget-title-border">
          {t('categories')}
        </h4>
        <div className="ltn__utilize-menu categories-menu">
          <ul>
            {categories.map(({title, alt, icon, subcategories}, idx) => {
              const hasActiveSubcategory = subcategories.some(sub => sub.alt === subcategoryInput);
              return (
                  <li key={idx} className={openedIdx === idx || hasActiveSubcategory ? 'active' : ''}>
                    <div className={`menu-title ${alt === categoryInput ? 'selected' : ''}`}>
                      <i className={icon}></i>
                      <Link
                          href={`/catalog?category=${alt}&title=${title}`}
                          onClick={(e) => onCategorySelect(e, alt, title, alt === categoryInput)}
                      >{title}</Link>
                    </div>
                    {Array.isArray(subcategories) && subcategories.length > 0 ? (
                        <ul className="sub-menu" style={openedIdx === idx || hasActiveSubcategory ? {display: 'block'} : {}}>
                          {subcategories.map(({title: title1, alt: alt1}, idx1) => (
                              <li key={idx1} className={alt1 === subcategoryInput ? 'selected' : ''}>
                                <Link
                                    href={`/catalog?subcategory=${alt1}&title=${title1}`}
                                    onClick={(e) => onSubcategory(e, alt1, title1, alt1 === subcategoryInput, idx)}
                                >
                                  {title1}
                                </Link>
                              </li>
                          ))
                          }
                        </ul>
                    ) : ('')}
                  </li>
              )
            })}
          </ul>
        </div>
      </div>
  );
};
